import styled from 'styled-components';
import { breakPoint, COLORS } from '@ertelecom/ui-react/assets/js/constants';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
import RadioButton from '@ertelecom/ui-react/components/controls/radioButton';

export const Wrapper = styled.div`
    display: block;
    width: 100%;
`;

export const Title = styled.h3`
    color: ${COLORS.black};
    width: 100%;
    font: 300 20px/28px "Roboto", sans-serif;
`;

export const Subtitle = styled.div`
    color: ${COLORS.black};
    font: 300 14px/18px "Roboto", sans-serif;
    margin-top: 5px;

    & + div {
        margin-top: 10px;
    }
`;

export const Text = styled.p`
    font: 300 16px/24px "Roboto", sans-serif;
    color: ${COLORS.darkGrey};
    margin-top: 13px;
    width: 100%;
`;

export const Icon = styled.img`
    display: block;
    width: 49px;
    height: 49px;
    margin: 0 auto 16px;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    margin-top: 42px;

    @media(${breakPoint(320)}) {
        align-items: center;
        flex-direction: column;
        margin-top: 30px;
    }
`;

export const CenterBlock = styled.div`
    text-align: center;
    width: 100%;

    & + {
        ${ButtonWrapper} {
            justify-content: center;
        }
    }
`;

export const Button = styled(StyledButton)`
    padding: 14px 20px;
    width: 184px;

    & + & {
        margin-left: 20px;
        width: 175px;

        @media(${breakPoint(320)}) {
            margin-left: 0;
            margin-top: 20px;
            width: 184px;
        }
    }
`;

export const ButtonPink = styled(Button)`
    background-color: rgba(237, 61, 61, 0.05);
    border: 1px solid rgba(237, 61, 61, 0.2);

    &:hover {
        background-color: rgba(237, 61, 61, 0.1);
        border-color: #ED3D3D;
    }
`;

export const Radio = styled(RadioButton)`
    margin-top: 6px;

    &:first-of-type {
        margin-top: 17px;
    }

    span {
        @media(${breakPoint(320)}) {
            top: 10px;
        }
    }
`;
